
import iconAddedBtn from '~/components/img/icon-added-btn.svg'
import catalogProduct from '~/components/Catalog/mixins/catalog-product'
import SetQtyInCart from '~/components/Catalog/SetQtyInCart'
import checkPrices from '~/mixins/checkPrices'
import { status } from '~/ZenOne-StoryBook/helpers/manufacturerLibrary'

export default {
  name: 'DistributorProductButton',
  components: { SetQtyInCart },
  mixins: [catalogProduct, checkPrices],
  props: {
    showProductPrice: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default() {
        return {}
      },
      required: true,
    },
  },
  data() {
    return {
      iconAddedBtn,
    }
  },
  computed: {
    isActiveStatus() {
      return this.item?.productDistributorStatus === status.ACTIVE
    },
    productDistributorId() {
      return this.item?.productDistributorId ?? null
    },
    isHavingOrderHistory() {
      const {
        item: { orderHistory = false },
      } = this
      return orderHistory
    },
    addToCartBtnText() {
      return !this.isHavingOrderHistory ? 'add to cart' : 'buy it again'
    },
    addToCartBtnTooltipText() {
      const noPriceText =
        'Click on the product to see your client price in real time'
      const { isPriceAvailable = false, isActiveStatus = false } = this
      if (!isActiveStatus) return 'This product is currently unavailable'
      else if (!isPriceAvailable) return noPriceText
      return ''
    },
    showConnectBtn() {
      return !this.isConnected
    },
    showAddToCartBtn() {
      const {
        item: { addedShoppingCart = false },
      } = this
      return !addedShoppingCart
    },
  },
  methods: {
    async addToCartBtnClickHandler() {
      const { productDistributorId = null } = this
      this.$emit('onAddProductToCart', {
        productDistributorId,
        qty: 1,
      })
      await this.initCheckingPrices(productDistributorId)
    },
    onChangeQtyInCart(data = {}) {
      this.$emit('onChangeQtyInCart', data)
    },
  },
}
